export function convertPyvarToMenhirLocale(locale) {
    if (!locale) return '';
    const localeParts = locale.split('-');
    if (localeParts.length > 1) {
        localeParts[1] = localeParts[1].toUpperCase();
    }
    return localeParts.join('_');
}

export function convertMenhirToPyvarPipeTranslate(menhirTranslation) {
    const reg = /(\[[a-z]{2})(_)([A-Z]{2}\])/g;

    return menhirTranslation.replace(reg, '$1-$3');
}

export function convertMenhirToPyvarLocale(locale) {
    if (!locale) return '';
    const localeParts = locale.split('_');
    if (localeParts.length > 1) {
        localeParts[1] = localeParts[1].toLowerCase();
    }
    return localeParts.join('-');
}

export function converPyvarToMenhirPipeTranslate(pyvarTranslation) {
    const reg = /(\[[a-z]{2})(-)([A-Z]{2}\])/g;

    return pyvarTranslation.replace(reg, '$1_$3');
}

export function cleanSingleTranslation(pipeStr, defaultLang) {
    const reg = /(\[[a-z]{2})(-)([A-Z]{2}\])/g;
    const locale = pipeStr.match(reg);
    if (locale?.length === 1 && locale[0] === `[${defaultLang}]`) pipeStr = pipeStr.replace(reg, '');
    return pipeStr;
}

export function addDefaultLanguageCode(pipeStr, locale) {
    const reg = /(\[[a-z]{2})(-)([A-Z]{2}\])/g;
    if (!pipeStr.match(reg) && pipeStr?.length) pipeStr = `[${locale}]${pipeStr}`;
    return pipeStr;
}

export function getPipeTranslationByLocale(pipeStr, locale) {
    if (!locale) return '';
    const found = pipeStr?.split(/\|?\[/g).find(str => str.slice(0, locale.length) === locale);
    if (!found) return '';
    const offset = locale.length + 1;
    return found?.slice(offset, found.length);
}

export function getAllTranslationsFromPipe(pipeStr, defaultLang, allLang) {
    const translations = {};
    const reg = /\|?\[(?<locale>([a-z]{2})(_)([A-Z]{2}))\]/g;
    let found = reg.exec(pipeStr);

    if (!found?.groups?.locale) {
        translations[defaultLang] = pipeStr;
    }

    const offsetLocales = [];
    for (let index = 0; found; index++) {
        let pyvarLocale = convertMenhirToPyvarLocale(found.groups.locale);
        // check that the locale is allowed and valid
        if (allLang.includes(pyvarLocale)) {
            if (index > 0) {
                offsetLocales[index - 1].end = found.index;
            }
            offsetLocales.push({
                locale: pyvarLocale,
                start: found.index + found['0'].length,
                end: pipeStr.length
            });
        }
        found = reg.exec(pipeStr);
    }

    offsetLocales.forEach(offset => {
        translations[offset.locale] = pipeStr.slice(offset.start, offset.end);
    });

    return translations;
}
